module.exports = __webpack_public_path__ + "static/media/spoonerism-task (7).2c02c223.mp3";